import { createContext } from 'react';

import type { AgentForgeBulkActivitySnapshot } from '../../../types/blocks/bulkOperation';

export interface AgentForgeBulkActivityContextValue {
  watchActivity: (_activityId: number) => () => void;
  getActivity: (
    _activityId: number
  ) => AgentForgeBulkActivitySnapshot | undefined;
  isActivityUnavailable: (_activityId: number) => boolean;
}

export const AgentForgeBulkActivityContext =
  createContext<AgentForgeBulkActivityContextValue | null>(null);
